import {
  SET_INVITE_ERROR_USERS,
  CLEAR_ERROR_USER,
} from '../types';

const initialState = {
  error: undefined,
  loading: true,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_INVITE_ERROR_USERS:
      return {
        ...state,
        error: action.error,
        loading: false,
      };
    case CLEAR_ERROR_USER:
      return {
        ...state,
        error: undefined,
      };
    default:
      return state;
  }
};
